export default __webpack_public_path__ + "static/media/bri-logo.7783e005.svg";